import script from "./ow-acc-cash-transactions.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-acc-cash-transactions.vue?vue&type=script&setup=true&lang=js"

import "./ow-acc-cash-transactions.vue?vue&type=style&index=0&id=ae52f5d0&lang=scss"

const __exports__ = script;

export default __exports__